/** Keep the draft mounted while inventory state changes. Submission owns execution readiness. */
import { useSavedEnvironmentRegistryStore } from "../../environments/runtime";
import { useCmmdRuntimeInventorySnapshot } from "../../cmmd/cmmdRuntimeInventoryResource";
import { getStoredLocalDeviceRuntimeId } from "../../deviceRegistryIdentity";
import { selectProjectsAcrossEnvironments, useStore } from "../../store";
import { useCmmdForgeRuntimeListSnapshot } from "../../cmmd/cmmdForgeRuntimeListResource";
import { NewThreadComposerLanding } from "./NewThreadComposerLanding";
import { useIsCloudControlSurface } from "./useIsCloudControlSurface";
import { resolveNewThreadLandingSurface } from "./newThreadLandingSurface";
import { selectDesktopInventoryProjects } from "./useDesktopRuntimeCatalog";

export function NewThreadLanding() {
  const savedEnvironmentsHydrated = useSavedEnvironmentRegistryStore((store) => store.hydrated);
  const savedEnvironmentCount = useSavedEnvironmentRegistryStore(
    (store) => Object.keys(store.byId).length,
  );
  const activeEnvironmentId = useStore((store) => store.activeEnvironmentId);
  const environmentStateById = useStore((store) => store.environmentStateById);
  const cloudCatalog = useCmmdForgeRuntimeListSnapshot();
  // Read the inventory snapshot and apply the catalog's own selector, rather than
  // mounting `useDesktopRuntimeCatalog()` — the composer body already mounts that
  // hook, and its `refresh()` has no in-flight coalescing, so a second mount puts
  // two concurrent GETs on the wire and lets the first to land clear `isLoading`
  // while the other is still outstanding. The selector keeps the online/synced
  // predicate defined once.
  const desktopInventoryProjects = selectDesktopInventoryProjects(
    useCmmdRuntimeInventorySnapshot(),
    getStoredLocalDeviceRuntimeId(),
  );
  const isCloudControlSurface = useIsCloudControlSurface();
  const surface = resolveNewThreadLandingSurface({
    savedEnvironmentsHydrated,
    savedEnvironmentCount,
    connectedProjectCount: selectProjectsAcrossEnvironments({
      activeEnvironmentId,
      environmentStateById,
    }).length,
    cloudCatalogRowCount: cloudCatalog.rows.length,
    desktopInventoryProjectCount: desktopInventoryProjects.length,
    cloudCatalogIsLoading: cloudCatalog.isLoading,
    cloudCatalogHasError: cloudCatalog.error !== null,
    isCloudControlSurface,
  });

  return (
    <NewThreadComposerLanding
      inventoryState={cloudCatalog.error !== null ? "cloud-catalog-unavailable" : surface}
    />
  );
}
